import axios from "axios";

axios.defaults.withCredentials = true;

const API = axios.create({
  baseURL: "https://server.mathtounsi.com/api", // HTTPS
  withCredentials: true,
});

// Access token helpers
export const setAccessToken = (token) => localStorage.setItem("access_token", token);
export const clearAccessToken = () => localStorage.removeItem("access_token");

// Request interceptor: attach access token
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: refresh on 401
API.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;

    if (
      err.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/auth/refresh")
    ) {
      originalRequest._retry = true;
      try {
        // Refresh token via HttpOnly cookie
        const refreshRes = await API.post("/auth/refresh", {}, { withCredentials: true });
        const newAccessToken = refreshRes.data.accessToken;

        // Save and retry
        setAccessToken(newAccessToken);
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return API(originalRequest);
      } catch (refreshErr) {
        clearAccessToken();
        console.warn("Refresh failed, redirect to login");
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(err);
  }
);

export default API;
